import React, { useEffect, useState } from "react";
// import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Modal, ModalBody } from "reactstrap";
import { useDispatch } from 'react-redux';
import { setLoader } from 'src/redux/reducers/loadingActionReducer';
import OutletSettingAddOrUpdate from "./OutletSettingAddOrUpdate";

const OutletSettingAddOrUpdateModal = ({ modalShow, setModalShow, isTitle, isUserDataById }) => {
    useEffect(() => {
        // fetchAllData();

    }, [])
    
    const dispatch = useDispatch();
    
    // const fetchAllData = async () => {
    //     dispatch(setLoader(true));
    //     try {
    //         const response1 = await umsApis.userApi.GetAllUmsAppProducts();
    //         if (response1 && response1.data && response1.data?.data) {
    //             setAppProductList(response1.data.data);
    //         }
    //     } catch (error) {
    //         // Handle the error here
    //     } finally {
    //         dispatch(setLoader(false));
    //     }
    // };
    let Icon;

    const toggle = () => {
        setModalShow(prevState => !prevState)
    }
    

    const handleSubmit = async (formValues) => {
        /* const uppercaseRegExp = /(?=.*?[A-Z])/;
         const lowercaseRegExp = /(?=.*?[a-z])/;
         const digitsRegExp = /(?=.*?[0-9])/;
         const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
         const minLengthRegExp = /.{8,}/;
         const uppercasePassword = uppercaseRegExp.test(formValues["password"]);
         const lowercasePassword = lowercaseRegExp.test(formValues["password"]);
         const digitsPassword = digitsRegExp.test(formValues["password"]);
         const specialCharPassword = specialCharRegExp.test(formValues["password"]);
         const minLengthPassword = minLengthRegExp.test(formValues["password"]);
         if (!(id && id > 0)) {
             if (!uppercasePassword || !lowercasePassword || !digitsPassword || !specialCharPassword || !minLengthPassword) {
                 showNotification(
                     "theme-light",
                     "ltr",
                     `SuccessCode: 500`,
                     `Message: Password Must be Strong`,
                 );
                 return;
             }
         }
 
         if (formValues["password"] !== formValues["confirmPassword"]) {
             showNotification(
                 "theme-light",
                 "ltr",
                 `SuccessCode: 500`,
                 `Message: Password Not Match`,
             );
             return;
         }*/
        dispatch(setLoader(true));
        let obj = {};
        obj["instId"] = formValues["instId"]["value"];

        // const response = await umsApis.userApi.AddOrUpdateUserInfo(obj).catch((error) => {
        //     dispatch(setLoader(false));
        // })

        // if (response.status === 200 && response.data.status===200) {
        if (true) {
            dispatch(setLoader(false));
           // setSuccess(true);
            //setSnackbarOpen(true);
        } else {
            dispatch(setLoader(false));
           // setFailed(true);
            // setFailedErrorMessage(response.data.description);
           // setSnackbarOpen(true);
        }

    };
    return (
        <div>
            <Modal
                isOpen={modalShow}
                toggle={toggle}
                modalClassName={`ltr-support`}
                className="theme-light ltr-support credit-memo-modal-form-ani">
                <div className="modal__header">
                    <button
                        className="lnr lnr-cross modal__close-btn"
                        aria-label="modal__close-btn"
                        type="button"
                        onClick={toggle}
                    />
                    {Icon}
                    <h4
                        className="text-modal  modal__title mt-1 text-uppercase"
                        style={{ color: "#2DD2E7" }}
                    >
                        {isTitle}
                    </h4>
                </div>
                <ModalBody className="m-0">
                    <div className="credit-memo-modal-form-ani">
                        {/* <span className="account__logo">
                            <span
                                className="account__logo-accent text-light"> */}
                                {/* form  */}

                                <OutletSettingAddOrUpdate                                 
                                     onSubmit={handleSubmit} isUserdataDataById={isUserDataById}
                                />

                            {/* </span>
                        </span> */}
                    </div>
                   

                </ModalBody>
            </Modal>


        </div>
    );
};

// MobileLicenceKeyUpdation.propTypes = {
//     title: PropTypes.string,
//     message: PropTypes.string,
//     color: PropTypes.string.isRequired,
//     header: PropTypes.bool,
// };

// MobileLicenceKeyUpdation.defaultProps = {
//     title: "",
//     message: "",
//     colored: false,
//     header: false,
// };

export default connect((state) => ({
    rtl: state.rtl,
}))(OutletSettingAddOrUpdateModal);
